var _defs, _style, _g, _path, _path2, _path3, _path4, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    width: 90,
    height: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "whatsappgrd1",
    gradientUnits: "userSpaceOnUse",
    cx: 63.027,
    cy: 69.947,
    r: 63
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsappgrd2",
    gradientUnits: "userSpaceOnUse",
    x1: 124.943,
    y1: 50.945,
    x2: 50.697,
    y2: 125.191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3abb6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21b56a"
  })), /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyAQMAAAAk8RryAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA5JREFUeJxjYBgFgwkAAAGQAAHTuxD+AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsappgrd3",
    gradientUnits: "userSpaceOnUse",
    x1: 248.082,
    y1: 246.993,
    x2: 173.836,
    y2: 321.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2671bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112d8d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "whatsappgrd4",
    gradientUnits: "userSpaceOnUse",
    cx: 45.787,
    cy: 67.683,
    r: 64.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsappgrd5",
    gradientUnits: "userSpaceOnUse",
    x1: 125.082,
    y1: 50.993,
    x2: 50.836,
    y2: 125.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2671bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsappgrd6",
    gradientUnits: "userSpaceOnUse",
    x1: 125.082,
    y1: 50.993,
    x2: 50.836,
    y2: 125.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2671bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112d8d"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan {\n\t\t\twhite-space: pre\n\t\t}\n\n\t\t.whatsappshp0 {\n\t\t\topacity: 0.8;\n\t\t\tmix-blend-mode: multiply;\n\t\t\tdisplay: none;\n\t\t\tfill: url(#whatsappgrd1)\n\t\t}\n\n\t\t.whatsappshp1 {\n\t\t\tfill: url(#whatsappgrd2)\n\t\t}\n\n\t\t.whatsappshp2 {\n\t\t\tfill: #ffffff\n\t\t}\n\n\t\t.whatsappshp3 {\n\t\t\tdisplay: none;\n\t\t\tfill: url(#whatsappgrd3)\n\t\t}\n\n\t\t.whatsappshp4 {\n\t\t\topacity: 0.8;\n\t\t\tmix-blend-mode: multiply;\n\t\t\tdisplay: none;\n\t\t\tfill: url(#whatsappgrd4)\n\t\t}\n\n\t\t.whatsappshp5 {\n\t\t\tfill: url(#whatsappgrd5)\n\t\t}\n\n\t\t.whatsappshp6 {\n\t\t\tfill: url(#whatsappgrd6)\n\t\t}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp0",
    d: "M126.03 69.95C126.03 104.74 97.82 132.95 63.03 132.95C28.23 132.95 0.03 104.74 0.03 69.95C0.03 35.15 28.23 6.95 63.03 6.95C97.82 6.95 126.03 35.15 126.03 69.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp1",
    d: "M1.01 66.04L1.01 24.21C1.01 11.59 11.34 1.26 23.96 1.26L65.79 1.26C78.41 1.26 88.74 11.59 88.74 24.21L88.74 66.04C88.74 78.66 78.41 88.99 65.79 88.99L23.96 88.99C11.34 88.99 1.01 78.66 1.01 66.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    className: "whatsappshp2",
    d: "M21.18 69.95L24.83 56.3C22.76 52.57 21.67 48.38 21.67 44.13C21.67 30.24 32.98 18.93 46.87 18.93C60.76 18.93 72.06 30.24 72.06 44.13C72.06 58.02 60.76 69.33 46.87 69.33C42.7 69.33 38.58 68.27 34.89 66.27L21.18 69.95ZM35.57 61.16L36.44 61.67C39.61 63.56 43.22 64.56 46.87 64.56C58.14 64.56 67.3 55.4 67.3 44.13C67.3 32.86 58.14 23.7 46.87 23.7C35.6 23.7 26.44 32.86 26.44 44.13C26.44 47.85 27.47 51.51 29.42 54.72L29.95 55.59L27.91 63.21L35.57 61.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp2",
    d: "M59.08 50.11C59.21 50.69 59.1 51.3 58.87 51.85C58.11 53.69 56.22 54.88 54.31 55.24C52.48 55.59 50.97 55.01 49.27 54.45C47.76 53.95 46.3 53.22 44.95 52.39C42.24 50.73 39.9 48.51 38.02 45.95C37.44 45.17 36.91 44.36 36.42 43.52C35.77 42.41 35.19 41.24 34.89 39.99C34.76 39.47 34.69 38.93 34.69 38.4C34.67 36.5 35.39 34.59 36.89 33.36C37.76 32.66 39.04 32.35 40.02 32.9C41.08 33.5 41.63 35.01 42.12 36.07C42.5 36.9 42.94 37.98 42.78 38.91C42.62 39.85 41.89 40.63 41.3 41.32C40.9 41.79 40.84 42.18 41.17 42.69C43.11 45.92 45.81 48.27 49.33 49.67C49.81 49.87 50.18 49.81 50.49 49.42C51.1 48.67 51.7 47.2 52.63 46.82C53.86 46.32 55.2 47.01 56.24 47.63C57.21 48.21 58.82 48.92 59.08 50.11Z"
  }))), /*#__PURE__*/React.createElement("use", {
    style: {
      display: "none"
    },
    href: "#img1",
    x: 20,
    y: 20
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp3",
    d: "M124.15 262.09L124.15 220.26C124.15 207.63 134.48 197.31 147.1 197.31L188.93 197.31C201.55 197.31 211.88 207.63 211.88 220.26L211.88 262.09C211.88 274.71 201.55 285.04 188.93 285.04L174.87 285.04L167.51 283.24L161.16 285.04L147.1 285.04C134.48 285.04 124.15 274.71 124.15 262.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp4",
    d: "M110.29 67.68C110.29 103.3 81.41 132.18 45.79 132.18C10.16 132.18 -18.71 103.3 -18.71 67.68C-18.71 32.06 10.16 3.18 45.79 3.18C81.41 3.18 110.29 32.06 110.29 67.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp5",
    d: "M1.15 66.09L1.15 24.26C1.15 11.63 11.48 1.31 24.1 1.31L65.93 1.31C78.55 1.31 88.88 11.63 88.88 24.26L88.88 66.09C88.88 78.71 78.55 89.04 65.93 89.04L51.87 89.04L44.51 87.24L38.16 89.04L24.1 89.04C11.48 89.04 1.15 78.71 1.15 66.09Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp6",
    d: "M1.15 66.09L1.15 24.26C1.15 11.63 11.48 1.31 24.1 1.31L65.93 1.31C78.55 1.31 88.88 11.63 88.88 24.26L88.88 66.09C88.88 78.71 78.55 89.04 65.93 89.04L51.87 89.04L44.51 87.24L38.16 89.04L24.1 89.04C11.48 89.04 1.15 78.71 1.15 66.09Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "whatsappshp2",
    d: "M51.87 59.29L51.87 89.04L38.16 89.04L38.16 59.29L27.02 59.29L27.02 46.61L38.16 46.61L38.16 36.95C38.16 25.96 44.71 19.88 54.73 19.88C57.93 19.88 61.2 20.17 64.55 20.74L64.55 31.53L59.02 31.53C53.57 31.53 51.87 34.92 51.87 38.39L51.87 46.61L64.03 46.61L62.09 59.29L51.87 59.29Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ccf5e23ebf85c7a19de2b1c943031a4b.svg";
export { ForwardRef as ReactComponent };